
var init = () => {

    document.addEventListener("click", function (e) {
        var element = e.target;

        if (element.hasAttribute("data-price-radio-value")) {

            var vals = document.querySelectorAll('[data-price-radio-value]')
            for (i = 0; i < vals.length; i++) {
                vals[i].classList.remove('is-active');
            }

            element.classList.add('is-active');

            e.preventDefault();
            e.stopImmediatePropagation();
            var value = element.getAttribute('value');

            if (value) {
                var splitVal = value.split('-');
                var GTE = splitVal[0];
                var LTE = splitVal[1];

                var gteElement = document.getElementById('Filter-Price-GTE');
                var lteElement = document.getElementById('Filter-Price-LTE');
                gteElement.value = GTE;
                lteElement.value = LTE;

                lteElement.dispatchEvent(new Event("input", { bubbles: true }));
                gteElement.dispatchEvent(new Event("input", { bubbles: true }));


            }
        }

    }, true)
};

init()
